import React from 'react';
import './LoaderSpinner.css';

const LoaderSpinner = () => {
    return (
        <div className='spinner'>
            
        </div>
    );
};

export default LoaderSpinner;